import { createTranslations } from '@npco/common-utils-translations'

export const accountStatementsTranslations = createTranslations({
  sectionTitle: 'Account Statements',
  tabMonthly: 'Monthly',
  tabQuarterly: 'Quarterly',
})
